import useStoreType from '../../../utils/hooks/useStoreType';
import { StoreBrandingType } from '../../../types/misc';
import SinglePageSkeletonFullLoading from './SinglePageSkeletonFullLoading';
import StoreLoadingSkeletonFullSite from './StoreLoadingSkeletonFullSite';
import ConciergeFullScreenLoading from './ConciergeFullScreenLoading';

const StoreFullScreenLoading = ({ storeHeader = false }: { storeHeader?: boolean }) => {
  const storeType = useStoreType();
  const isConciergePage = typeof window !== 'undefined' && window.location.pathname.startsWith('/concierge');

  if (isConciergePage) {
    return <ConciergeFullScreenLoading />;
  }
  if (!storeType) {
    // Deterministic fallback while appConfig / storeBrandingType hydrates.
    // We don't guess branding from hostname; we use a single safe default.
    return <StoreLoadingSkeletonFullSite header={storeHeader} />;
  }
  if (storeType === StoreBrandingType.CustomDTCStore) {
    return <SinglePageSkeletonFullLoading includeHeader={storeHeader} />;
  }
  return <StoreLoadingSkeletonFullSite header={storeHeader} />;
};

export default StoreFullScreenLoading;
